"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _SliderButton = _interopRequireDefault(require("@airasia/phoenix-components/components/SliderButton"));

var _Card = _interopRequireDefault(require("../Card"));

var _constant = require("../constant");

var _constant2 = require("@airasia/phoenix-components/components/constant");

var _CarouselSlider = _interopRequireDefault(require("./CarouselSlider.proptypes"));

var _constant3 = require("./constant");

var _constant4 = require("../Card/constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var StyledContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "CarouselSlider__StyledContainerWrapper",
  componentId: "sc-fmic93-0"
})(["position:relative;width:100%;height:100%;"]);

var ScrollBehavior = (0, _styledComponents.css)(["scroll-behavior:smooth;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;-ms-scroll-snap-type:x mandatory;-webkit-scroll-snap-type:x mandatory;"]);

var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "CarouselSlider__StyledContainer",
  componentId: "sc-fmic93-1"
})(["overflow:auto;width:100%;position:relative;transition:scroll ease-out 0.45s;", ";height:100%;"], ScrollBehavior);

var ProductCategoryMobileViewGridStyle = function ProductCategoryMobileViewGridStyle(gridSize) {
  var size = gridSize || '7';
  return (0, _styledComponents.css)(["grid-template-columns:repeat(", ",calc(100% / ", "));grid-auto-columns:calc(100% / ", ");"], size, size, size);
};

var ProductCategoryDesktopViewGridStyle = function ProductCategoryDesktopViewGridStyle(gridSize) {
  var size = gridSize || '16';
  return (0, _styledComponents.css)(["grid-template-columns:repeat(", ",calc(100% / ", "));grid-auto-columns:calc(100% / ", ");"], size, size, size);
};

var GalleryCardDesktopViewGridStyle = (0, _styledComponents.css)(["grid-template-columns:repeat(6,calc(100% / 6));grid-auto-columns:calc(100% / 6);-ms-grid-columns:(calc(100% / 6))[6];grid-template-rows:auto;height:100%;"]);
var GalleryCardTabletViewGridStyle = (0, _styledComponents.css)(["grid-template-columns:repeat(4,calc(100% / 4));grid-auto-columns:calc(100% / 4);-ms-grid-columns:(calc(100% / 4))[4];height:100%;"]);
var RecommendedHotelCardGridStyle = (0, _styledComponents.css)(["grid-template-columns:repeat(4,calc(100% / 4));grid-auto-columns:calc(100% / 4);-ms-grid-columns:(calc(100% / 4))[4];height:100%;"]);
var GalleryCardMobileViewGridStyle = (0, _styledComponents.css)(["grid-template-columns:repeat(2,calc(100% / 2));grid-auto-columns:calc(100% / 2);-ms-grid-columns:(calc(100% / 2))[2];height:100%;"]);

var returnMobileGridStyle = function returnMobileGridStyle(template) {
  var customGridTemplate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (template) {
    case _constant4.TEMPLATE_TYPE.PRODUCT_CARD:
    case _constant4.TEMPLATE_TYPE.VERTICAL_CONTENT_CARD:
      return (0, _styledComponents.css)(["grid-template-columns:repeat(4,calc(100% / 4));grid-auto-columns:calc(100% / 4);-ms-grid-columns:(calc(100% / 4))[4];"]);

    case _constant4.TEMPLATE_TYPE.PRODUCT_CATEGORY:
      return ProductCategoryMobileViewGridStyle(customGridTemplate === null || customGridTemplate === void 0 ? void 0 : customGridTemplate.mobile);

    case _constant4.TEMPLATE_TYPE.PRODUCT_GALLERY:
      return GalleryCardMobileViewGridStyle;

    default:
      return null;
  }
};

var returnDesktopGrid = function returnDesktopGrid(template) {
  var customGridTemplate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (template) {
    case _constant4.TEMPLATE_TYPE.PRODUCT_CARD:
    case _constant4.TEMPLATE_TYPE.VERTICAL_CONTENT_CARD:
      return (0, _styledComponents.css)(["grid-template-columns:repeat(12,calc(100% / 12));grid-auto-columns:calc(100% / 12);-ms-grid-columns:(calc(100% / 12))[12];"]);

    case _constant4.TEMPLATE_TYPE.PRODUCT_CATEGORY:
      return ProductCategoryDesktopViewGridStyle(customGridTemplate === null || customGridTemplate === void 0 ? void 0 : customGridTemplate.desktop);

    case _constant4.TEMPLATE_TYPE.PRODUCT_GALLERY:
      return GalleryCardDesktopViewGridStyle;

    default:
      return null;
  }
};

var returnTabletGrid = function returnTabletGrid(template) {
  switch (template) {
    case _constant4.TEMPLATE_TYPE.PRODUCT_GALLERY:
    case _constant4.TEMPLATE_TYPE.VERTICAL_CONTENT_CARD:
    case _constant4.TEMPLATE_TYPE.SNAP_CARD:
      return GalleryCardTabletViewGridStyle;

    case _constant4.TEMPLATE_TYPE.HOTEL_CARD:
      return RecommendedHotelCardGridStyle;

    default:
      return (0, _styledComponents.css)(["grid-template-columns:repeat(8,calc(100% / 8));grid-auto-columns:calc(100% / 8);-ms-grid-columns:(calc(100% / 8))[8];"]);
  }
};

var StyledCarouselWrapper = _styledComponents.default.div.withConfig({
  displayName: "CarouselSlider__StyledCarouselWrapper",
  componentId: "sc-fmic93-2"
})(["", " display:grid;width:100%;grid-auto-flow:column;", " @media screen and (max-width:", "){", " overflow:scroll;.carousel-card:first-child{padding-left:", ";}.carousel-card:last-child{padding-right:", ";}}@media screen and (min-width:", "){", "}@media screen and (min-width:", "){", "}@media screen and (min-width:", "){", "}", ";"], function (_ref) {
  var isIE = _ref.isIE;
  return isIE && (0, _styledComponents.css)(["display:-ms-grid;"]);
}, function (_ref2) {
  var templateType = _ref2.templateType,
      customGridTemplate = _ref2.customGridTemplate;
  return returnDesktopGrid(templateType, customGridTemplate);
}, _constant.BREAKPOINTS.MOBILE, function (_ref3) {
  var templateType = _ref3.templateType,
      customGridTemplate = _ref3.customGridTemplate;
  return returnMobileGridStyle(templateType, customGridTemplate);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.tiny;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.tiny;
}, _constant.BREAKPOINTS.SMALL_TABLET, function (_ref6) {
  var templateType = _ref6.templateType;
  return returnTabletGrid(templateType);
}, _constant.BREAKPOINTS.MEDIUM_TABLET, function (_ref7) {
  var templateType = _ref7.templateType;
  return returnTabletGrid(templateType);
}, _constant.BREAKPOINTS.LARGE_TABLET, function (_ref8) {
  var templateType = _ref8.templateType,
      customGridTemplate = _ref8.customGridTemplate;
  return returnDesktopGrid(templateType, customGridTemplate);
}, ScrollBehavior);

var SliderButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "CarouselSlider__SliderButtonContainer",
  componentId: "sc-fmic93-3"
})(["position:absolute;bottom:50%;", ";width:32px;height:32px;"], function (_ref9) {
  var direction = _ref9.direction;
  return direction === 'right' ? "right: -8px" : "left: -15px";
});

var CarouselSlider = function CarouselSlider(props) {
  var theme = props.theme,
      data = props.data,
      queryParams = props.queryParams,
      columnSpan = props.columnSpan,
      templateType = props.templateType,
      cardConfig = props.cardConfig,
      accessible = props.accessible,
      customProperties = props.customProperties,
      isIE = props.isIE,
      fireGtm = props.fireGtm,
      gtmEventData = props.gtmEventData,
      showFormattedPrice = props.showFormattedPrice,
      allowLocaleFormat = props.allowLocaleFormat,
      locale = props.locale,
      localeConfig = props.localeConfig,
      isHideFooter = props.isHideFooter,
      widgetID = props.widgetID,
      viewPort = props.viewPort,
      handleCardVisibility = props.handleCardVisibility,
      visibleCardCount = props.visibleCardCount,
      idConfig = props.idConfig,
      environment = props.environment,
      enableProgressiveImageLoading = props.enableProgressiveImageLoading,
      lazyLoadImage = props.lazyLoadImage,
      decimalType = props.decimalType,
      gaID = props.gaID,
      isGeneric = props.isGeneric,
      children = props.children,
      customCardHeaderHeight = props.customCardHeaderHeight,
      hideBorder = props.hideBorder;

  var _useState = (0, _react.useState)(viewPort ? viewPort === _constant2.DEVICE_TYPE.MOBILE : typeof window !== 'undefined' && window.innerWidth < 600),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      hasPrev = _useState4[0],
      sethasPrev = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      hasNext = _useState6[0],
      sethasNext = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      cardWidth = _useState8[0],
      setCardWidth = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      containerWidth = _useState10[0],
      setContainerWidth = _useState10[1];

  var _useState11 = (0, _react.useState)(0),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      scrollWidth = _useState12[0],
      setScrollWidth = _useState12[1];

  var container = (0, _react.useRef)(null);
  var carouselWrapper = (0, _react.useRef)(null);
  var cardCustomProps = {
    className: 'carousel-card'
  };

  var customCardConfig = _objectSpread(_objectSpread({}, cardConfig), {}, {
    customProperties: cardCustomProps
  });

  var updateMedia = function updateMedia() {
    if (typeof window !== 'undefined') setIsMobile(window.innerWidth < 600);
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      setIsMobile(window.innerWidth < 600);
      window.addEventListener('resize', updateMedia);
    }
  }, []);
  (0, _react.useEffect)(function () {
    // const container = document.getElementById('container');
    // const card = document.getElementById('carousel-wrapper').children;
    var card = carouselWrapper.current && carouselWrapper.current.children;

    if (container.current !== null) {
      if (container.current.clientWidth === container.current.scrollWidth) {
        sethasPrev(false);
        sethasNext(false);
      } else {
        sethasNext(true);
      }

      setCardWidth(card && card[0] && card[0].clientWidth);
      setContainerWidth(container.current.clientWidth);
      setScrollWidth(container.current.scrollWidth - container.current.clientWidth);
    }

    return function () {
      return typeof window !== 'undefined' ? window.removeEventListener('resize', updateMedia) : null;
    };
  }, [columnSpan, visibleCardCount]);

  var checkButtonVisibility = function checkButtonVisibility(scrollPosition) {
    if (scrollPosition === 0) {
      sethasPrev(false);
      sethasNext(true);
    } else {
      sethasPrev(true);

      if (scrollPosition >= scrollWidth) {
        sethasNext(false);
      } else {
        sethasNext(true);
      }
    }
  };

  var SliderButtonVisibility = function SliderButtonVisibility() {
    // const container = document.getElementById('container');
    if (isMobile) {
      return;
    }

    checkButtonVisibility(container.current.scrollLeft);
  };

  var nextSlide = function nextSlide() {
    // const container = document.getElementById('container');
    var updatedScrollLeft = container.current.scrollLeft + (containerWidth - cardWidth);
    container.current.scrollLeft = updatedScrollLeft;
    checkButtonVisibility(updatedScrollLeft);
  };

  var prevSlide = function prevSlide() {
    // const container = document.getElementById('container');
    var updatedScrollLeft = container.current.scrollLeft - (containerWidth - cardWidth);
    updatedScrollLeft = updatedScrollLeft >= 0 ? updatedScrollLeft : 0;
    container.current.scrollLeft = updatedScrollLeft;
    checkButtonVisibility(updatedScrollLeft);
  };

  var tabIndex = !accessible ? '-1' : '0';
  var dataExists = data && Object.keys(data).length !== 0;
  var isEmpty = data && Object.values(data).every(function (x) {
    return x === null || x === '';
  });
  var formattedPrice;
  var formattedOriginalPrice; // is showFormattedPrice is true then based on viewPort get appropriate formattedPrice and pass it to CarouselCards

  var getData = function getData(dataObj) {
    if (dataObj && showFormattedPrice) {
      formattedPrice = !isMobile ? dataObj.formattedPriceWeb : dataObj.formattedPriceMob;
      formattedOriginalPrice = !isMobile ? dataObj.formattedOriginalPriceWeb : dataObj.formattedOriginalPriceMob;
    }

    return _objectSpread(_objectSpread({}, dataObj), {}, {
      formattedPrice: formattedPrice,
      formattedOriginalPrice: formattedOriginalPrice
    });
  };

  var cardConfigCustomGridSize = null;

  if (cardConfig !== null && cardConfig !== void 0 && cardConfig.customGridTemplate) {
    cardConfigCustomGridSize = cardConfig.customGridTemplate;
  }

  return data && data !== null && dataExists && !isEmpty ? /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainerWrapper, (0, _extends2.default)({
    tabIndex: tabIndex,
    id: "container-wrapper-".concat(widgetID)
  }, customProperties), /*#__PURE__*/_react.default.createElement(StyledContainer, {
    onScroll: SliderButtonVisibility,
    id: "container",
    ref: container
  }, /*#__PURE__*/_react.default.createElement(StyledCarouselWrapper, {
    templateType: templateType,
    isIE: isIE,
    id: "carousel-wrapper",
    tabIndex: "-1",
    ref: carouselWrapper,
    customGridTemplate: cardConfigCustomGridSize
  }, isGeneric ? children : data.map(function (dataObj, index) {
    return /*#__PURE__*/_react.default.createElement(_Card.default, (0, _extends2.default)({
      templateType: templateType,
      idConfig: idConfig // eslint-disable-next-line react/no-array-index-key
      ,
      key: "d_".concat(index, "_").concat(isMobile, "_").concat(templateType),
      index: "".concat(index),
      data: getData(dataObj),
      showFormattedPrice: showFormattedPrice,
      queryParams: queryParams,
      columnSpan: columnSpan,
      isIE: isIE,
      environment: environment,
      theme: theme,
      enableProgressiveImageLoading: enableProgressiveImageLoading,
      fireGtm: fireGtm,
      lazyLoadImage: lazyLoadImage,
      gtmEventData: gtmEventData,
      cardWidth: cardWidth,
      accessible: accessible,
      allowLocaleFormat: allowLocaleFormat,
      locale: locale,
      localeConfig: localeConfig,
      isHideFooter: isHideFooter,
      isMobile: isMobile,
      handleCardVisibility: handleCardVisibility
    }, customCardConfig, {
      decimalType: decimalType,
      gaID: gaID,
      customCardHeaderHeight: customCardHeaderHeight,
      hideBorder: hideBorder
    }));
  }))), !isMobile && hasPrev && templateType !== _constant4.TEMPLATE_TYPE.HOTEL_CARD && /*#__PURE__*/_react.default.createElement(SliderButtonContainer, {
    direction: "left"
  }, /*#__PURE__*/_react.default.createElement(_SliderButton.default, {
    handleClick: prevSlide,
    icon: _constant3.ICON.SLIDER_BUTTON_LEFT,
    theme: theme,
    accessible: false
  })), !isMobile && hasNext && templateType !== _constant4.TEMPLATE_TYPE.HOTEL_CARD && /*#__PURE__*/_react.default.createElement(SliderButtonContainer, {
    direction: "right"
  }, /*#__PURE__*/_react.default.createElement(_SliderButton.default, {
    handleClick: nextSlide,
    icon: _constant3.ICON.SLIDER_BUTTON_RIGHT,
    theme: theme,
    accessible: false
  })))) : null;
};

CarouselSlider.propTypes = _CarouselSlider.default.PropTypes;
CarouselSlider.defaultProps = _CarouselSlider.default.DefaultProps;
var _default = CarouselSlider;
exports.default = _default;